import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { useAppContext } from 'utils/hooks';
import errorPng from 'assets/rr-illustrations/lost.png';
import { ReactComponent as SystemCrashIcon } from 'assets/ss-icons/zero-state-icons/system-crash.svg';

const RELOAD_DEFAULT_FUNCTION = () => {};

export default function PageErrorUi({
  isError = false,
  hideImage = false,
  onReload = RELOAD_DEFAULT_FUNCTION,
  reloadButtonText = 'Try reloading',
  reloadButtonType = 'outline',
  msg = 'Unable to load',
  wrapperClassName = '',
  contentClassName = '',
  imageClassName = '',
  children = null
}) {
  const { isSSRMode } = useAppContext();

  if (!isError) return children;

  const isReloadButtonVisible =
    onReload &&
    onReload !== RELOAD_DEFAULT_FUNCTION &&
    onReload instanceof Function;

  return (
    <div className={cn(styles.container, wrapperClassName)}>
      {!hideImage &&
        (isSSRMode ? (
          <SystemCrashIcon className={cn(styles.image, imageClassName)} />
        ) : (
          <img
            className={cn(styles.image, imageClassName)}
            src={errorPng}
            alt="lost"
          />
        ))}
      <div className={cn(styles.content, contentClassName)}>
        <p className={styles.msg}>{msg}</p>
        <If test={isReloadButtonVisible}>
          <UiKit.Button variant="outline" onClick={() => onReload()}>
            {reloadButtonText}
          </UiKit.Button>
        </If>
      </div>
    </div>
  );
}
